<template>

  <!-- 弹出向导层 start-->
  <div id="pop" class="pop" v-show="pop_show">
    <span class="pop_bg" @click="closeshow()"></span>

    <div id="pop_bodyup" class="pop_content">
      <!-- 动态查询区生成 -->
      <div class="pop_head_close">
        <a class="close" href="javascript:void(0);" @click="closeshow()"></a>
      </div>
      <div>
        <h5>{{title}}&nbsp;&nbsp;<span class="red">操作说明:略!。</span> </h5>
      </div>

      <div class="content_edit">
        <div class="content_edit_item">
          <button class="pre_btn_ok" @click="refresh_data()">
            刷新
          </button>
          <button class="pre_btn_ok" @click="fun_upd_item('_add')">
            保存
          </button>
          <button class="pre_btn_ok" @click="excelup()">
            导入
          </button>
        </div>
      </div>
      <div class="inline-row">
        <div class="content_edit_item">
          <label>模板名称:{{mode_name}}</label>
        </div>
        <div class="content_edit_item" v-for="(item,index) in parm" :key="index">

          <component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_all">
          </component>

        </div>
        <!-- <div class="content_edit_item" >
						<label >备注:</label>
						<input type="text" class="long1" v-model="note"  />
						<em>*</em>
					</div> -->
      </div>
      <div class="inline-row-tab">
        <div class="inline-tab">
          <table class="dataintable mark_tab">
            <tr class="tab_header">
              <td>ID</td>
              <td>序号</td>
              <td>模板名称</td>
              <td>状态</td>
              <td>修改人</td>
              <td>更新时间</td>
              <td class="short0 cen">编辑</td>
            </tr>
            <tr :id="'pop_m_'+item.row_num" v-for="(item,index) in list_title" :key="index"
              @click="sel_row(item,'edit')">
              <td>{{item.id}}</td>
              <td>{{item.row_num}}</td>
              <!-- <td>{{item.name}}</td> -->
              <td><input type="text" style="width: 120px;" v-model="item.name" @keyup.enter="sel_row(item,'add')" />
              </td>
              <td>{{item.flag}}</td>
              <td>{{item.u_name}}</td>
              <td>{{item.sys_date}}</td>
              <td class="short0 cen">
                <button @click="sel_row(item,'add')">保存</button>
                <button @click="sel_row(item,'del')">删除</button>
              </td>
            </tr>
          </table>
        </div>
        <div class="inline-tab">
          <table class="dataintable mark_tab">
            <tr class="tab_header">
              <td>ID</td>
              <td>序号</td>
              <td>物品编号</td>
              <td>物品名称</td>
              <td>单价</td>
              <td>数量</td>
              <td>修改人</td>
              <td>更新时间</td>
              <td class="short0 cen">编辑</td>
            </tr>
            <tr :id="'pop_md_'+item.row_num" v-for="(item,index) in list_item" :key="index"
              @click="sel_row_d(item,'edit')">
              <td>{{item.id}}</td>
              <td>{{item.row_num}}</td>
              <td>{{item.item_no}}</td>
              <td>{{item.item_name}}</td>
              <td>{{item.item_price}}</td>
              <td>{{item.item_qry}}</td>
              <!-- <td><input type="text" style="width: 120px;" v-model="item.name" @keyup.enter="sel_row(item,'add')" />
              </td> -->
              <td>{{item.u_name}}</td>
              <td>{{item.sys_date}}</td>
              <td class="short0 cen">
                <button @click="fun_upd_item('_del',item)">删除</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 通用导入excel -->
    <per-excelup ref="excelup" @excelup-event="fun_refresh_excelup" :pre_th="d_parm" :api_url="d_sel_action"
      :api_action="d_upd_action" :api_method="'exp15'" :api_check="''" />


  </div>
  <!-- 弹出向导层 end-->


</template>

<script>
  /*
名称：等级划分
日期：2022-03-19
作者：hj
目标：
方法 传入参数，
1、查询标识
2、编辑标识
*/

  import api from '@/utils/type.js';
  import {
    Sel_page_and_length,
    Method_Common
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "pre_mark_tan",
    components: {
      "pre-table": () => import("../auto/auto_view_table.vue"),
      'per-excelup': () => import("../auto/auto_excel_up.vue")
    },
    data() {
      return {
        element_loading: false,
        pop_show: false,
        show_btn: true,
        load_url: '',
        load_json: '',
        upd_json: '',
        screenWidth: '',
        screenHeight: '',

        title: '未设置标题',
        sheet_no: '',
        sel_action: '',
        upd_action: '',
        row_id: '',
        sel_item: [], //备份点击项目
        sys_date: '',

        parm: [], //参数结构
        parm_th: [], //标题
        kw1: '',
        kw2: '',
        kw3: '',

        max_row: [],

        list_title: [],
        mode_name: '',
        sys_val: 0,
        note: '',

        list_item: [],
        item_id: 0,
        item_name: '',

        // post_select: ''
        tid:0,
       tsysdate:'',
        d_parm: [], //参数结构
        d_sel_action: '',
        d_upd_action: '',

      };
    },
    methods: {
      showpop: function(parm) {
        this.pop_show = true;
        var Hg = $(document).height();
        // 设置背景高度
        $(".pop_bg").height(Hg);
        // 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
        $(".pop_bg").fadeIn("3000");
        $(".pop_content").fadeIn("3000");
        this.load_data(parm)
      },
      closeshow: function() {
        this.pop_show = false;
        $(".pop_bg").fadeOut("3000");
        $(".pop_content").fadeOut("3000");
        this.screenHeight = 0;
        this.screenWidth = 0;
      },
      NextTickName: function(key) {
        return 'pre' + key;
      },
      checkJson: function(d) {
        let temp = '';
        temp = JSON.stringify(d)
        return temp;
      },
      refresh_view_all: function(d, type) {
        // console.log(d);
        for (let i = 0; i < this.parm.length; i++) {
          if (this.parm[i].key == d.key) {
            this.parm[i].val = d.val;
            break;
          }
        }

      },
      load_data: function(res) {

        this.parm = [{
            "name": "物品名称",
            "val": "",
            "key": "item_name",
            "type": "select",
            "class": "long1",
            "sel_action": "_base_caritembase",
            "sel_name": "",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "1"
          }, {
            "name": "物品单价",
            "val": "",
            "key": "item_price",
            "type": "number",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "1"
          },
          {
            "name": "物品数量",
            "val": "",
            "key": "item_qty",
            "type": "number",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "1"
          }
        ]



        this.refresh_data();

      },
      refresh_data: function() {
        // console.log('刷新sheet_no='+this.sheet_no);
        this.row_id = '';
        this.sys_date = '';

        this.element_loading = true;
        this.list_title = [];

        let r = (Math.random() + '').substring(0, 8);

        this.$post(
          api.http_method, Sel_page_and_length('exp_store_car_itemmode', 1, 100)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          if (res.length > 0) {
            let t = res[0];
            for (let i = 0; i < t.length; i++) {
              t[i].row_num = i + 1;
              this.list_title.push(t[i]);
            }


          }

          let o = {};
          o.id = 0;
          o.row_num = this.list_title.length + 1;
          o.name = '';
          o.u_name = '';
          o.sys_date = '';
          this.list_title.push(o);
        });
        // this.change_style();
      },
      sel_row: function(item, type) {
        // console.log(item, 'type=' + type);
        // console.log(this.parm);
        // 判断 obj.hasOwnProperty("key")
        //2、遍历Json串获取其属性
        this.row_id = item.id;
        this.sys_date = item.sys_date;
        this.mode_name = item.name;

        this.d_parm = [{
            "name": "模板名称",
            "val": item.id,
            "key": "item_mode",
            "type": "text",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "1"
          },
          {
            "name": "物品编号",
            "val": "",
            "key": "item_no",
            "type": "text",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "1"
          },
          {
            "name": "物品名称",
            "val": "",
            "key": "item_name",
            "type": "text",
            "class": "long1",
            "p": "0",
            "w": "0",
            "r": "0",
            "x": "1"
          },
          {
            "name": "物品单价",
            "val": "",
            "key": "item_price",
            "type": "number",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "1"
          },
          {
            "name": "物品数量",
            "val": "",
            "key": "item_qty",
            "type": "number",
            "class": "long1",
            "p": "1",
            "w": "0",
            "r": "0",
            "x": "1"
          },
        ]

        this.d_sel_action = 'exp_store_car_itemmode_d';
        this.d_upd_action = '_store_car_d_itemmode';


        switch (type) {
          case 'edit': // 切换背景色
            let key = 'pop_m_';

            for (var i = 0; i < this.list_title.length; i++) {
              if (this.list_title[i].row_num == item.row_num) {
                document.getElementById(key + item.row_num).style.background = '#92a4f3';
              } else {
                if (this.list_title[i].row_num % 2 == 0) {
                  document.getElementById(key + this.list_title[i].row_num).style.background =
                    '#fff';
                } else {
                  document.getElementById(key + this.list_title[i].row_num).style.background =
                    '#f5f5f5';
                }
              }
            }
            break;
            // case 'show': // 打开编辑页面
            // 	this.$refs.file_table.showpop();
            // 	break;
          case 'add': // 执行保存
            this.fun_upd('_add');
            break;
          case 'del': // 执行保存
            this.fun_upd('_del');
            break;
          default:
            break;
        }

        if (this.row_id > 0) {
          this.refresh_item();
        }

      },
      fun_upd: function(type) {
        console.log('操作类型=' + type);

        let d = [];
        d.push(this.mode_name);
        d.push(this.note);

        let r = (Math.random() + '').substring(0, 8);
        // console.log(d);
        let temp_data = '';
        temp_data = Method_Common('_store_car_itemmode' + type, this.row_id, this.sys_date, d, r);

        this.$post(
          api.http_method, temp_data
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          console.log(res);
          if (res.data.status == 1) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });

            this.refresh_data();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });

      },
      fun_upd_item: function(type, item) {
        // console.log('操作类型=' + type);
        // console.log('删除明细=' , item);



        let d = [];
        if (type == '_add') {
          if (this.row_id == 0) {
            this.$message({
              message: '请点击要编辑的模板名称!',
              type: 'warning'
            });
            return;
          }
          d.push(this.row_id);
          d.push(this.parm[0].val);
          d.push(this.parm[1].val);
          d.push(this.parm[2].val);
        } else {
          this.tid = item.id;
          this.tsysdate = item.sys_date;
        }


        let r = (Math.random() + '').substring(0, 8);
        // console.log(d);
        let temp_data = '';
        temp_data = Method_Common('_store_car_d_itemmode' + type, this.tid, this.tsysdate, d, r);

        this.$post(
          api.http_method, temp_data
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });

            this.refresh_item();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });

      },
      refresh_item: function() {
        this.element_loading = true;
        this.list_item = [];

        let r = (Math.random() + '').substring(0, 8);

        this.$post(
          api.http_method, Sel_page_and_length('exp_store_car_itemmode_d', 1, 100, this.row_id)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          if (res.length > 0) {
            let t = res[0];
            for (let i = 0; i < t.length; i++) {
              t[i].row_num = i + 1;
              this.list_item.push(t[i]);
            }
            console.log(this.list_item);
          }
        });
      },
      sel_row_d: function(item, type) {
        // console.log(item, 'type=' + type);
        // console.log(this.parm);
        // 判断 obj.hasOwnProperty("key")
        //2、遍历Json串获取其属性
        this.tid = item.id;
        this.tsysdate = item.sys_date;

        for (let i = 0; i < this.parm.length; i++) {
          switch (this.parm[i].key) {
            case 'item_name':
              this.parm[i].val = item.item_name;
              this.parm[i].sel_name = item.item_name;
              break;
            case 'item_qty':
              this.parm[i].val = item.item_qry;
              break;
            case 'item_price':
              this.parm[i].val = item.item_price;
              break;
            default:
              break;
          }
        }

        switch (type) {
          case 'edit': // 切换背景色
            let key = 'pop_md_';

            for (var i = 0; i < this.list_item.length; i++) {
              if (this.list_item[i].row_num == item.row_num) {
                document.getElementById(key + item.row_num).style.background = '#92a4f3';
              } else {
                if (this.list_item[i].row_num % 2 == 0) {
                  document.getElementById(key + this.list_item[i].row_num).style.background =
                    '#fff';
                } else {
                  document.getElementById(key + this.list_item[i].row_num).style.background =
                    '#f5f5f5';
                }
              }
            }
            break;
            // case 'show': // 打开编辑页面
            // 	this.$refs.file_table.showpop();
            // 	break;
          default:
            break;
        }

        if (this.row_id > 0) {
          this.refresh_item();
        }

      },
      excelup: function() {
        if (Number(this.row_id) == 0) {
          this.$message({
            message: ' 请先选择一个模板名称,再点导入!',
            type: 'warning'
          });
          return
        }

        var that = this;
        this.$nextTick(function() {
          that.$refs['excelup'].show_edit();
        });

      },
      fun_refresh_excelup: function() {
        this.refresh_item();
      },






    }
  };
</script>


<style scoped>
  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }

  .content_edit_item button {
    margin-right: 8px;
  }

  .inline-row {
    line-height: 28px;
  }

  .inline-row-tab {
    display: inline-flex;
    align-items: flex-start;
  }

  .inline-tab {
    display: inline-flex;
    margin: 2px;
  }

  .mark_tab tr td:nth-child(1) {
    display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  }

  /*  .mark_tab tr td:nth-child(3) {
	  display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  	text-align: center;
  } */
</style>
